export default {
    cta: "Fragen Sie einen<br/> Berater",
    ordered: "Bestellt am {date}"
}